// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"22c806cd","455":"288bd830","977":"a2885f81"}[chunkId] + ".chunk.js";
};